type HighEntropyUAData = {
  getHighEntropyValues?: (hints: string[]) => Promise<{ model?: string }>
};

let deviceModel = '';

const uaData = (navigator as unknown as { userAgentData?: HighEntropyUAData }).userAgentData;

uaData?.getHighEntropyValues?.(['model'])
  .then(({ model }) => {
    const value = (model || '').trim();
    if (/^[\x20-\x7E]{1,64}$/.test(value)) {
      deviceModel = value;
    }
  })
  .catch(() => undefined);

export const getDeviceModel = () => deviceModel;
